// useSubscriptionStore.js
import { create } from "zustand";

const useSubscriptionStore = create((set) => ({
  // State to store the selected subscription plan
  selectedPlan: null,
  isPaymentSuccessful: false,
  isModalHidden: false,

  // Action to update the selected plan
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  setIsPaymentSuccessful: (value) => set({ isPaymentSuccessful: value }),
  setIsModalHidden: (value) => set({ isModalHidden: value }),
}));

export default useSubscriptionStore;
